import { render, staticRenderFns } from "./ShippingService.vue?vue&type=template&id=39734e8e&"
import script from "./ShippingService.vue?vue&type=script&lang=js&"
export * from "./ShippingService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports